import { render, staticRenderFns } from "./DeleteDeviceModal.vue?vue&type=template&id=50b504b4"
import script from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"
export * from "./DeleteDeviceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports